import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { CartInitialState } from './initialState';

export const selectCartState = (state: RootState) => state.cart;
export const selectActiveBusinessId = (state: RootState) => state.cart.activeBusinessId;
export const selectActiveCart = createSelector(
  [selectCartState, selectActiveBusinessId],
  (cartState, activeBusinessId) => (activeBusinessId ? cartState.carts[activeBusinessId]?.cart : CartInitialState)
);
export const selectActiveCartItems = createSelector([selectActiveCart], (cart) => cart?.items || []);
export const selectCartTotals = createSelector([selectActiveCart], (cart) => ({
  subtotal: cart?.actualPrice || 0,
  discounted: cart?.discountedPrice || 0,
  itemCount: cart?.items?.length || 0,
  quantity: cart?.orderedQuantity || 0,
}));
export const selectIsLoading = (state: RootState) => state.cart.isLoading;
export const selectCartId = (state: RootState) => state.cart.cartId;

export const selectActiveOrderingTime = createSelector(
  [selectCartState, selectActiveBusinessId],
  (cartState, activeBusinessId) => (activeBusinessId ? cartState.carts[activeBusinessId]?.orderingTime : null)
);

export const selectActiveRestaurant = createSelector(
  [selectCartState, selectActiveBusinessId],
  (cartState, activeBusinessId) => (activeBusinessId ? cartState.carts[activeBusinessId]?.restaurant : null)
);

export const selectIsCartDirty = createSelector(
  [selectCartState, selectActiveBusinessId],
  (cartState, activeBusinessId) => (activeBusinessId ? cartState.carts[activeBusinessId]?.isDirty : false)
);

export const selectCartExists = (businessId: number) =>
  createSelector([selectCartState], (cartState) => !!cartState.carts[businessId]);
